import { useEffect } from 'react';

// Hotkey Navigation Constants
export const HOTKEY_NAV = {
	BACK: 	-1,
	FORWARD: 1,
};

// keysConfig: [{ key: 'F8', down: handlerFunction, up: handlerFunction }, ...]
export default function useHotkeyHandlers(keysConfig = []) {
	useEffect(() => {
		function handleKeyDown(e) {
			const hotKey = keysConfig.find(config => config.key === e.key);
			if (!hotKey) return;

			if (e.repeat) return; // Ignore repeated keydown events
			
			if (typeof hotKey.down === 'function') {
				hotKey.down(e);
			}
		}

		function handleKeyUp(e) {
			const hotKey = keysConfig.find(config => config.key === e.key);
			if (!hotKey) return;
			
			if (typeof hotKey.up === 'function') {
				hotKey.up(e);
			}
		}

		document.addEventListener('keydown', handleKeyDown);
		document.addEventListener('keyup', handleKeyUp);

		return () => {
			document.removeEventListener('keydown', handleKeyDown);
			document.removeEventListener('keyup', handleKeyUp);
		};
	}, [keysConfig]);
}